<template>
    <div class="carousel-section" data-aos="fade-up">
        <div class="container px-4 py-24 mx-auto show-on-scroll">
            <div class="mb-12 text-4xl leading-none text-center text-000 md:text-5xl title-text">
                Hear from Our Happy Parents
            </div>
            <carousel 
                class="w-full" 
                :autoHeight="true" 
                :autoplay="true" 
                :autoplayTimeout="5000" 
                :dots="true" 
                :loop="true" 
                :nav="false" 
                :rewind="true" 
                :responsive="{
                    0: {
                        items: 1
                    }
                }"
            >
                <div class="w-full" v-for="(review, i) in reviews" :key="i">
                    <div class="flex flex-wrap justify-center mb-8">
                        <div class="w-full text-center md:w-2/3 lg:w-1/3">
                            <img :src="review.image" class="inline-block">
                        </div>
                    </div>
                </div>
            </carousel>
        </div>
    </div>
</template>

<script>
    import carousel from 'vue-owl-carousel'

    export default {
        components: {
            carousel
        },
        data () {
            return {
                reviews: [
                    {
                        image: '/images/testimonial-01.jpg'
                    },
                    {
                        image: '/images/testimonial-02.jpg'
                    },
                    {
                        image: '/images/testimonial-03.jpg'
                    },
                    {
                        image: '/images/testimonial-04.jpg'
                    },
                    {
                        image: '/images/testimonial-05.jpg'
                    },
                    {
                        image: '/images/testimonial-06.jpg'
                    },
                    {
                        image: '/images/testimonial-07.jpg'
                    },
                    {
                        image: '/images/testimonial-08.jpg'
                    }
                ]
            }
        }
    }
</script>

<style>

</style>